import { render, staticRenderFns } from "./PGPView.vue?vue&type=template&id=b0706d04&scoped=true"
import script from "./PGPView.vue?vue&type=script&lang=js"
export * from "./PGPView.vue?vue&type=script&lang=js"
import style0 from "./PGPView.vue?vue&type=style&index=0&id=b0706d04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0706d04",
  null
  
)

export default component.exports